
'use strict';

const $ = jQuery.noConflict();
$(function() {

	const heroSingleVideo = {

		init: function() {
			this.cacheDOM();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$overlay = $('.js-hero-video-overlay');
			this.$iframe = $('.js-hero-video-iframe');
			this.$playBtn = $('.js-hero-play-btn');
		},

		bindEvents: function() {
			this.$playBtn.on('click', this.playVideo.bind(this));

			this.$overlay.on('click', (e) => {
				if (e.target === this.$overlay[0]) {
					this.playVideo();
				}
			});
		},

		getEmbedUrl: function(url) {
			let videoId = '';
			const patterns = [
				/youtu\.be\/([a-zA-Z0-9_-]+)/,
				/[?&]v=([a-zA-Z0-9_-]+)/,
				/\/embed\/([a-zA-Z0-9_-]+)/,
				/\/shorts\/([a-zA-Z0-9_-]+)/,
			];

			for (const pattern of patterns) {
				const match = url.match(pattern);
				if (match) {
					videoId = match[1];
					break;
				}
			}

			if (videoId) {
				return 'https://www.youtube.com/embed/' + videoId + '?enablejsapi=1&rel=0&modestbranding=1&controls=1';
			}

			return url;
		},

		playVideo: function() {
			const videoSrc = this.$iframe.attr('data-src');

			if (videoSrc && !this.$iframe.attr('src')) {
				const embedUrl = this.getEmbedUrl(videoSrc);
				this.$iframe.attr('src', embedUrl + '&autoplay=1');
			}

			this.$overlay.addClass('is-hidden');
		},

	};

	if ($('.js-hero-video-wrap').length) {
		heroSingleVideo.init();
	}

});
